import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=6321807c&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style0 from "./manage.vue?vue&type=style&index=0&id=6321807c&lang=scss&scoped=true&"
import style1 from "./manage.vue?vue&type=style&index=1&id=6321807c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321807c",
  null
  
)

export default component.exports